"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceDataStats = exports.isDataSample = exports.isInstanceApiStats = exports.isApiSample = void 0;
const validation_1 = require("../validator/validation");
const datelike_1 = require("../types/datelike");
exports.isApiSample = (0, validation_1.isObjectOf)({
    at: datelike_1.isDateLike,
    count: validation_1.isNumber,
});
exports.isInstanceApiStats = (0, validation_1.isObjectOf)({
    api: (0, validation_1.isArrayOf)(exports.isApiSample),
});
exports.isDataSample = (0, validation_1.isObjectOf)({
    at: datelike_1.isDateLike,
    data: validation_1.isNumber,
    indexedData: validation_1.isNumber,
});
exports.isInstanceDataStats = (0, validation_1.isObjectOf)({
    data: (0, validation_1.isArrayOf)(exports.isDataSample),
});
//# sourceMappingURL=metrics.js.map